import { autonomyActionTypes } from '@/pages/autonomy/Constants';

import type { Step } from '@/pages/learningPath/types';

export function getAutonomyStepsRequest() {
	return {
		type: autonomyActionTypes.GET_AUTONOMY_STEPS_REQUEST,
	};
}

export function getAutonomyStepsSuccess(steps: Step[]) {
	return {
		type: autonomyActionTypes.GET_AUTONOMY_STEPS_SUCCESS,
		payload: {
			steps,
		},
	};
}

export function getAutonomyStepsError() {
	return {
		type: autonomyActionTypes.GET_AUTONOMY_STEPS_ERROR,
	};
}

export function setDraggingState(isDragging: boolean) {
	return {
		type: autonomyActionTypes.SET_DRAGGING_STATE,
		payload: {
			isDragging,
		},
	};
}

export function saveStepsPositionRequest(
	autonomySteps: Step[],
	orderedSteps: Step[],
	steps: Step[],
	skipped: boolean,
) {
	return {
		type: autonomyActionTypes.SAVE_STEPS_POSITION_REQUEST,
		payload: {
			autonomySteps,
			orderedSteps,
			steps,
			skipped,
		},
	};
}

export function saveStepsPositionSuccess() {
	return {
		type: autonomyActionTypes.SAVE_STEPS_POSITION_SUCCESS,
	};
}

export function saveStepsPositionError() {
	return {
		type: autonomyActionTypes.SAVE_STEPS_POSITION_ERROR,
	};
}

export function toggleAutonomyModal(openAutonomyModal: boolean) {
	return {
		type: autonomyActionTypes.TOGGLE_AUTONOMY_MODAL,
		payload: {
			openAutonomyModal,
		},
	};
}

export function saveEngageTimeRequest(engageTime: number) {
	return {
		type: autonomyActionTypes.SAVE_ENGAGE_TIME_REQUEST,
		payload: {
			engageTime,
		},
	};
}

export function saveEngageTimeSuccess() {
	return {
		type: autonomyActionTypes.SAVE_ENGAGE_TIME_SUCCESS,
	};
}

export function saveEngageTimeError() {
	return {
		type: autonomyActionTypes.SAVE_ENGAGE_TIME_ERROR,
	};
}
